import { ArrowRight } from 'lucide-react';
import '@/Sections.css';

const CASES = [
  { n: '01', t: 'Das Produkt gibt es noch nicht', d: 'Prototyp oder CAD-Datei reicht: Wir zeigen dein Produkt im fertigen Film, bevor das erste Stück vom Band läuft.' },
  { n: '02', t: 'Die Location wäre unbezahlbar', d: 'Wüste, Skyline, Fantasiewelt: Schauplätze, die real zu teuer, zu weit weg oder schlicht erfunden sind – ohne Reise- und Setkosten.' },
  { n: '03', t: 'Die Kampagne startet nächste Woche', d: 'Kein Drehtag, kein Casting, kein Wetterrisiko: Erste Ergebnisse gibt es in Tagen statt Wochen.' },
  { n: '04', t: 'Du willst Varianten testen', d: 'Dieselbe Szene in mehreren Stimmungen, Formaten und Sprachen – perfekt für A/B-Tests deiner Anzeigen.' },
  { n: '05', t: 'Dein Thema ist unsichtbar', d: 'Software, Dienstleistung, Prozess: Wir machen Abstraktes filmisch erlebbar, wo ein klassischer Dreh banal oder unbezahlbar würde.' },
  { n: '06', t: 'Kino-Look ohne Kino-Budget', d: 'Cineastische Bilder ohne Crew, Technik und Studiomiete – ein Bruchteil der klassischen Drehkosten.' },
];

export default function UseCases() {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="usecases-section" data-testid="usecases-section">
      <div className="container">
        <h2 className="section-title" data-testid="usecases-title" data-reveal>Wann ist KI-Video die bessere Wahl?</h2>
        <p className="section-subtitle" data-reveal>Überall dort, wo ein realer Dreh zu teuer, zu langsam oder unmöglich wäre</p>

        <div className="usecases-grid" data-reveal="stagger">
          {CASES.map((c) => (
            <div className="usecase-card" key={c.n} data-testid={`usecase-${c.n}`}>
              <span className="usecase-number">{c.n}</span>
              <h3>{c.t}</h3>
              <p>{c.d}</p>
            </div>
          ))}
          <div className="usecase-card usecase-cta" data-testid="usecase-cta">
            <span className="usecase-number">+</span>
            <h3>Deine Idee ist nicht dabei?</h3>
            <p>Erzähl uns davon – fast alles lässt sich heute generieren. Wir finden den passenden Weg.</p>
            <button className="usecase-button" data-magnetic="true" data-testid="usecase-cta-button" onClick={scrollToContact}>
              Anfragen <ArrowRight size={16} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
